export default __webpack_public_path__ + "assets/orion-nebula.01b21c1e.jpg";